export default "/images/14b13cbbadafc86df0d3fbd9312b1f43.avif";